import {useParams} from 'react-router'
import {goBack} from '~/routing/actions'
import {BillingInfo, backend} from '@eitje/api'
import {Text, EitjeButton, Layout, Dropdown, DropdownItem, PageHeader, Popout} from '~/components'

export const BillingInfoHeader = ({company_name}) => {
	const {id} = useParams()

	return (
		<PageHeader
			type="floating"
			left={[
				<EitjeButton iconLeft="arrow-left" onClick={goBack} />,
				<Text bold fontSize={18}>
					{company_name}
				</Text>,
			]}
			right={[
				<EitjeButton t="common.edit" iconLeft="pencil" modalLink={`/billing/billing_infos/${id}/edit`} />,
				<OptionsDropdown key={1} />,
			]}
		/>
	)
}

const OptionsDropdown = () => {
	const {id} = useParams()
	const {mollie_dashboard_url} = BillingInfo.useFind(id)

	const revokeMollie = () => {
		backend.put(`billing_infos/${id}/revoke_mollie`)
		BillingInfo.index()
	}

	return (
		<Layout>
			<Dropdown trigger={{iconRight: 'chevron-small-down', t: 'common.options'}}>
				<DropdownItem t="billing.open_mollie" iconLeft="external-link" externalLink={mollie_dashboard_url} />
				<DropdownItem t="billing.price_agreement.name" iconLeft="pencil" modalLink={`/billing/billing_infos/${id}/price_agreement`} />
				<Popout
					trigger={{iconLeft: 'cross-circled', t: 'billing.revoke_mollie'}}
					type="confirm"
					placement="right-start"
					title={{t: 'billing.revoke_mollie_title'}}
					body={{t: 'billing.revoke_mollie_body'}}
					confirmButtonProps={{
						t: 'billing.revoke_mollie_confirm',
						iconLeft: 'cross-circled',
						baseColor: 'red',
						onClick: revokeMollie,
					}}
				/>
			</Dropdown>
		</Layout>
	)
}
